<template>
  <datatable
    :url="ajaxUrl"
    :create-url="createUrl"
    :order-by="orderBy"
    :order-asc="orderAsc"
    refresh-on="reloadTable"
    search-placeholder="Search all formulas..."
  >
    <template #headings>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="name"
        @set-order-by="setOrder"
      >
        Name
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="created_at"
        @set-order-by="setOrder"
      >
        Created at
      </sortableTh>
      <th></th>
    </template>
    <template #rows="{ data }">
      <tr v-for="formula in data" :key="formula.id">
        <td>{{ formula.name }}</td>
        <td>{{ formula.created_at }}</td>
        <td v-html="formula.actions"></td>
      </tr>
    </template>
  </datatable>
</template>

<script setup>
import { ref } from "vue";
import datatable from "@/components/datatable.vue";
import sortableTh from "@/components/datatable/sortableTh.vue";

const props = defineProps({
  ajaxUrl: String,
  createUrl: String,
});

const orderBy = ref("created_at");
const orderAsc = ref(false);

const setOrder = function (input) {
  if (orderBy.value == input) {
    orderAsc.value = !orderAsc.value;
  } else {
    orderBy.value = input;
    orderAsc.value = true;
  }
};
</script>
